import { Link } from "react-router-dom";

export const Logo = ({ size = "h-9 w-9", withText = true, testid = "header-logo" }) => (
  <Link to="/" className="group flex items-center gap-3" data-testid={testid}>
    <img src="/logo.png" alt="vyne Logo" className={`${size} rounded-[22%] ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-105`} />
    {withText && <span className="font-sans text-sm font-medium tracking-[0.45em] text-[#FAF7F0]">VYNE</span>}
  </Link>
);
